/* eslint-disable no-unused-vars */
import { Button, Grid, Typography } from "@mui/material";
import { blue, green, grey, orange, red, yellow } from "@mui/material/colors";

import { createMuiTheme, ThemeProvider } from "@mui/material/styles";

import { makeStyles, withStyles } from "@mui/styles";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PAuthenticationWindow from "../../components/pos/PAuthenticationWindow";
import PRSelect from "../../components/pos/PRSelect";
import { AgentUtils } from "../../utils/AgentUtils";
import { PrintUtils } from "../../utils/PrintUtils";
import { SaleUtils } from "../../utils/SaleUtils";
import { Store } from "../../utils/Store";
import PSelect from "../../components/pos/PSelect";
const useStyles = makeStyles({});

const theme = createMuiTheme({
  status: {
    danger: blue[500],
  },
});

const ActionButton = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "1rem",
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500],
    "&:hover": {
      backgroundColor: blue[700],
    },
  },
}))(Button);

export default function TradingActionPanel(props) {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [showAuthScreen, setShowAuthScreen] = useState(false);
  const [salesMan, setSalesMan] = useState();
  const [paymentMode, setPaymentMode] = useState("");
  const [paymentModeOptions, setPaymentModeOptions] = useState([
    { name: "CREDIT", id: "CREDIT" },
    { name: "CASH", id: "CASH" },
    { name: "BANK", id: "BANK" },
  ]);

  var biRef = {};

  useEffect(() => {
    console.log("props.salesManInfo", props.salesManInfo);
    if (props.salesManInfo) {
      setSalesMan({
        value: props.salesManInfo,
        label: props.salesManInfo.name,
      });
    } else {
      setSalesMan(null);
    }
  }, [props.salesManInfo]);

  useEffect(() => {
    console.log(
      "props.tradingScreenPaymentModeSelect",
      props.tradingScreenPaymentModeSelect
    );
    if (props.tradingScreenPaymentModeSelect) {
      setPaymentMode({
        id: props.tradingScreenPaymentModeSelect.id,
        name: props.tradingScreenPaymentModeSelect.name,
      });
    } else {
      setPaymentMode(null);
    }
  }, [props.tradingScreenPaymentModeSelect]);

  function reprint() {
    PrintUtils.rePrint(
      props.terminalBean,
      props.setAlert,
      translate,
      false,
      props.pdfViewer
    );
  }

  function handleLoginSucessResponse(authToken) {
    if (
      window.JSBridge &&
      typeof window.JSBridge !== "undefined" &&
      window.JSBridge !== null
    ) {
      let baseUrl = window.JSBridge.getBaseURL();
      getPrivileges(baseUrl, authToken);
    } else {
      getPrivileges("", authToken);
    }
  }

  async function getPrivileges(baseUrl, authToken) {
    try {
      const response = await fetch(baseUrl + "/auth/v1/users/myPrivileges", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + authToken,
        },
      });
      if (response.status === 200) {
        const json = await response.json();
        if (props.setPrivileges) {
          props.setPrivileges(json);
          props.setCurrentUser(Store.parseJwt(authToken).sub);
        }
      }
    } catch (e) {
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Something went wrong!"),
      });
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container style={{ height: "100%" }}>
            <Grid item xs={12} style={{ paddingLeft: 5, marginTop: 5 }}>
              Salesman
            </Grid>
            <Grid item xs={12} style={{ paddingLeft: 5, marginTop: 5 }}>
              <PRSelect
                options={props.salesMans}
                defaultOptions={props.salesMans}
                onChange={(e) => {
                  props.setSalesManInfo(e.value);
                }}
                value={salesMan}
              ></PRSelect>
            </Grid>
            <Grid item xs={6} style={{ padding: 2, marginTop: 5 }}>
              <ActionButton
                disabled={!props.privileges.History_buttun_allowed}
                onClick={() => props.handleShowHistoryClick()}
                style={{
                  backgroundColor: blue[600],
                }}
              >
                {translate("History")}
              </ActionButton>
            </Grid>
            <Grid item xs={6} style={{ padding: 2, marginTop: 5 }}>
              <ActionButton
                disabled={!props.privileges.drawer_buttun_allowed}
                style={{
                  backgroundColor: blue[600],
                }}
                onClick={() => {
                  props.setCurrentScreen("productLookup");
                }}
              >
                {translate("Lookup")}
              </ActionButton>
            </Grid>
            <Grid item xs={6} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.reprint_buttun_allowed}
                style={{
                  backgroundColor: blue[600],
                }}
                onClick={() => {
                  reprint();
                }}
              >
                {translate("REPRINT")}
              </ActionButton>
            </Grid>
            <Grid item xs={6} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.switch_button_allowed}
                onClick={() => setShowAuthScreen(true)}
                style={{
                  backgroundColor: blue[600],
                }}
              >
                {translate("Switch")}
              </ActionButton>
            </Grid>
            <Grid item xs={6} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.switch_button_allowed}
                onClick={() => {
                  let position = props.getAgGridCurrentRow();
                  if (position >= 0)
                    props.setValue(
                      props.saleData[position][9].info.saleItemNote
                    );
                  else props.setValue("");
                  props.setShowValueCapture(true);
                }}
                style={{
                  backgroundColor: blue[600],
                }}
              >
                {translate("Note")}
              </ActionButton>
            </Grid>
            <Grid item xs={6} style={{ padding: 2 }}></Grid>
            <Grid item xs={6} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.hold_buttun_allowed}
                onClick={() => {
                  if (props.saleData.length == 0) {
                    props.setAlert({
                      show: true,
                      title: translate("Alert!"),
                      message: translate("Please add some items"),
                    });
                    return;
                  }
                  props.setShowHoldWindow(true);
                }}
                style={{
                  backgroundColor: yellow[900],
                }}
              >
                {translate("HOLD")}
              </ActionButton>
            </Grid>
            <Grid item xs={6} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.unhold_buttun_allowed}
                onClick={() => props.setShowUnHoldWindow(true)}
                style={{
                  backgroundColor: yellow[900],
                }}
              >
                {translate("UNHOLD")}
              </ActionButton>
            </Grid>

            <Grid item xs={6} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.remove_buttun_allowed}
                onClick={() => props.removeItemAgGrid()}
                style={{
                  backgroundColor: red[600],
                }}
              >
                {translate("Remove")}
              </ActionButton>
            </Grid>
            <Grid item xs={6} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.void_buttun_allowed}
                onClick={() => {
                  props.resetSale();
                }}
                style={{
                  backgroundColor: red[600],
                }}
              >
                {translate("VOID")}
              </ActionButton>
            </Grid>

            <Grid item xs={12} style={{ padding: 2, marginTop: 10 }}>
              <PSelect
                label="Payment Type"
                options={paymentModeOptions}
                value={paymentMode}
                onChange={(event, newValue) => {
                  console.log("newValue", newValue);
                  props.setTradingScreenPaymentModeSelect(newValue);
                }}
              ></PSelect>
            </Grid>

            {/* <Grid item xs={12} style={{ padding: 2, marginTop: 10 }}>
              <Typography variant="subtitle1" gutterBottom component="div">
                Payment Mode
              </Typography>
            </Grid> */}

            {/* <Grid item xs={6} style={{ padding: 2, paddingRight: "3px" }}>
              <ActionButton
                onClick={() => {
                  props.setPaymentMode("CASH");
                }}
                style={{
                  height: "25px",
                  backgroundColor:
                    props.paymentMode === "CASH" ? orange[800] : grey[400],
                }}
              >
                {translate("CASH")}
              </ActionButton>
            </Grid> */}
            {/* <Grid item xs={6} style={{ padding: 2, paddingLeft: "3px" }}>
              <ActionButton
                disabled={
                  !(props.customerBean && props.customerBean.creditCustomer)
                }
                onClick={() => {
                  props.setPaymentMode("CREDIT");
                }}
                style={{
                  height: "25px",

                  backgroundColor:
                    props.paymentMode === "CREDIT" &&
                    props.customerBean &&
                    props.customerBean.creditCustomer
                      ? orange[800]
                      : grey[400],
                }}
              >
                {translate("CREDIT")}
              </ActionButton>
            </Grid> */}
            <Grid
              item
              xs={12}
              style={{
                height:
                  AgentUtils.getWindowDimensionsExAppBars().h - 525 + "px",
              }}
            ></Grid>
            <Grid item xs={12} style={{ padding: 2, marginTop: 80 }}>
              <ActionButton
                style={{ backgroundColor: blue[700] }}
                onClick={() => {
                  props.persistSale(false, true);
                }}
              >
                {translate("Save")}
              </ActionButton>
            </Grid>

            <Grid item xs={12} style={{ padding: 2, marginTop: 5 }}>
              <ActionButton
                style={{ backgroundColor: blue[700] }}
                onClick={() => {
                  props.persistSale(true);
                }}
              >
                {translate("Save & Print")}
              </ActionButton>
            </Grid>
            <Grid item xs={12} style={{ padding: 2, marginTop: 5 }}>
              <ActionButton
                style={{ backgroundColor: blue[700] }}
                onClick={() => {
                  props.showPaymentWindow(true);
                }}
              >
                {translate("Settle")}
              </ActionButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {showAuthScreen && (
        <PAuthenticationWindow
          context={props.context}
          handleLoginSucessResponse={handleLoginSucessResponse}
          showWindow={setShowAuthScreen}
        ></PAuthenticationWindow>
      )}
    </ThemeProvider>
  );
}
